<template>
    <div class="main">
        <topback title="Transaction"></topback>
        <div class="content">
            <card color="#f3f3f6">
                <div slot="card-body">
                    <md-field class="assetslist">
                        <md-cell-item title="I Token" :addon="$store.state.userinfo.itoken">
                            <div class="holder" slot="left">
                                <iconimg name="i" class="assetslist-img"></iconimg>
                            </div>
                        </md-cell-item>
                    </md-field>
                    <div class="btngroup">
                        <div class="btnitem">
                            <iconimg name="inpaying" class="holder"></iconimg>
                            <span class="title">In transaction</span>
                            <span class="title">{{ $store.state.userinfo.inpay_quota }}</span>
                        </div>
                        <div class="btnitem">
                            <iconimg name="profit" class="holder"></iconimg>
                            <span class="title">Deal amount</span>
                            <span class="title">{{ $store.state.userinfo.success_totalamount }}</span>
                        </div>
                        <div class="btnitem">
                            <iconimg name="profit" class="holder"></iconimg>
                            <span class="title">Total profit</span>
                            <span class="title">{{ $store.state.userinfo.profit }}</span>
                        </div>
                    </div>
                    <md-cell-item title="Today Profit" :addon="$store.state.userinfo.today_profit">
                        <div class="holder" slot="left">
                            <iconimg name="gift"></iconimg>
                        </div>
                    </md-cell-item>
                </div>
            </card>

            <div class="tablist">
                <md-tab-bar v-model="current" :items="items" @change="onTabChange"></md-tab-bar>
                <md-swiper ref="swiper" :autoplay="0" :is-prevent="false" :is-loop="false" :has-dots="false" @before-change="onSwiperChange">
                    <md-swiper-item>
                        <md-field-item title="Payment Options" :plain="true" class="mt-3">
                            <span slot="right" @click="go_buy_tutorial">Buy Tutotial</span>
                            <div class="payment-options" slot="children">
                                <md-radio-box class="payment-options-radio" name="inr" v-model="recharge_method" label="INR"
                                    icon-position="lt" />
                                <md-radio-box class="payment-options-radio" name="usdt" v-model="recharge_method"
                                    label="USDT" />
                            </div>
                        </md-field-item>

                        <md-input-item ref="inr_amount" v-model="amount" placeholder="Enter the amount" is-virtual-keyboard
                            virtual-keyboard-vm="myNumberKeyBoard" clearable class="mt-3" :error="amount_error"
                            v-if="recharge_method === 'inr'">
                            <span slot="left"> ₹ </span>
                            <div slot="right">
                                <span class="usdt-text">= {{ principal }} IToken</span>
                            </div>
                        </md-input-item>

                        <md-input-item ref="usdt_amount" v-model="amount" placeholder="Enter the quantity"
                            is-virtual-keyboard virtual-keyboard-vm="myNumberKeyBoard" clearable class="mt-3"
                            :error="amount_error" v-if="recharge_method === 'usdt'">
                            <iconimg name="usdt" slot="left"></iconimg>
                            <div slot="right">
                                <span class="usdt-text">≈ {{ principal }} IToken</span>
                            </div>
                        </md-input-item>

                        <md-number-keyboard type="professional" ref="myNumberKeyBoard" ok-text="Ok"></md-number-keyboard>
                        <p class="reward-text mt-3">
                            Estimated Reward Itoken: {{ reward }} ({{ $store.state.userinfo.bonus_ratio }}% + <span
                                class="sii-gift">TT gift: {{ gift }}</span>)
                        </p>
                        <p class="reward-text mt-3"> You will receive: {{ get_itoken }} Itoken </p>
                        <div class="inbtn">
                            <md-button type="primary" class="mt-3" @click="confirm_buy"> Confirm Buy </md-button>
                        </div>
                       
                        <p class="free-text mt-3">Exchange is free of charge.</p>
                    </md-swiper-item>
                    <md-swiper-item>
                        <md-field-item title="Sell mode" :plain="true" class="mt-3">
                            <div class="payment-options" slot="children">
                                <md-radio-box class="payment-options-radio" name="entrust" v-model="sell_method"
                                    label="Entrust" icon-position="lt" />
                                <md-radio-box class="payment-options-radio" name="c2c" v-model="sell_method" label="Block Trade" />
                            </div>
                        </md-field-item>

                        <md-field-item>
                            <div slot="default">
                                <div class="usdt-text" v-if="sell_method === 'entrust'">
                                    <p>Automatically entrust your Itoken to you for sale</p>
                                    <p>TT providing you with security and asset safety</p>
                                    <p>You can stop consignment sale at any time</p>
                                </div>
                                <div class="usdt-text" v-else>
                                    <p>Sell your iToken, TT will match you with the best buyers!</p>
                                </div>
                            </div>
                        </md-field-item>

                        <div v-if="sell_method === 'entrust'">
                            <md-cell-item :title="availablect_text" brief="Active KYC Partner">
                                <span slot="right" @click="go_manage_kyc">
                                    Manage kyc partner
                                </span>
                            </md-cell-item>
                            <div class="inbtn">   
                                <md-button type="primary" class="mt-3" @click="start_entrust">{{ sell_btn }}</md-button>
                            </div>
                        </div>
                        <div v-else>
                            <md-cell-item :title="availablepay_text" brief="Payment methods">
                                <span slot="right" @click="go_manage_payment_methods">
                                    Manage Payment methods
                                </span>
                            </md-cell-item>
                            <div class="inbtn">
                                <md-button type="primary" class="mt-3" @click="start_c2c">{{ sell_c2c_btn }}</md-button>
                            </div>
                        </div>
                    </md-swiper-item>

                </md-swiper>
            </div>
        </div>
        <navbar></navbar>
    </div>
</template>

<script>
import topback from '@/components/topback'
import navbar from '@/components/navbar'
import goodscard from '@/components/goodscard'
import pointtext from '@/components/pointtext'
import iconimg from '@/components/iconimg'
import card from '@/components/card'
import { Dialog } from 'mand-mobile'
import { getcwexchangerate, availablect, startsell, organization, getpayments } from '@/request/api'

export default {
    name: 'transaction',
    components: {
        [topback.name]: topback,
        [navbar.name]: navbar,
        [goodscard.name]: goodscard,
        [pointtext.name]: pointtext,
        iconimg,
        card
    },
    data() {
        return {
            current: 0,
            items: [{ name: 0, label: 'Buy' }, { name: 1, label: 'Sell' }],
            recharge_method: "usdt",
            amount: "",

            exchangerate: 90,
            reward: 0,
            get_itoken: 0,
            gift: 0,
            principal: 0,
            amount_error: "",

            sell_method: "entrust",
            availablect_count: 0,
            availablect_text: "In Active: 0",
            availablepay_count: 0,
            availablepay_text: "In Active: 0",

            sell_btn: "Start Sell",
            sell_c2c_btn: "Start Sell"

        }
    },
    watch: {
        amount(newVal, oldVal) {
            if (newVal <= 0) {
                this.amount_error = "incorrect amount";
                this.reward = 0;
                this.get_itoken = 0;
                this.gift = 0;
                this.principal = 0;
                return;
            } else {
                this.amount_error = "";
                this.calculate_itoken(newVal);
            }
        },
        recharge_method(newVal, oldVal) {
            this.amount_error = "";
            this.reward = 0;
            this.get_itoken = 0;
            this.gift = 0;
            this.principal = 0;
            this.amount = "";
        },
        sell_method(newVal, oldVal) {
            if (newVal === 'entrust') {
                this.get_availablect_count();
            } else {
                this.get_payments_count();
            }
        },
    },
    created() {
        this.get_cwexchangerate();
        this.$store.dispatch("asyncupdateuserinfo").then(res => {
            this.in_sell_btn(res);
        });
        this.$store.dispatch("asyncupdatesiteconfig");
    },
    mounted() {
        this.$nextTick(() => {
            const footerNavHeight = this.$el.querySelector('.footer_nav').offsetHeight;
            this.$el.querySelector('.content').style.paddingBottom = footerNavHeight + 'px';
        });
    },
    methods: {
        go_tg_channel() {
            window.location.href = this.$store.state.siteconfig.tg_channel_link;
        },
        in_sell_btn(userinfo) {
            if (userinfo.in_sell) {
                this.sell_btn = "In Sell";
            }
            if(userinfo.in_c2c) {
                this.sell_c2c_btn = "In Sell";
            }
        },
        start_entrust() {
            if (this.$store.state.userinfo.in_sell) {
                this.$router.push('/sell');
                return;
            }
            let that = this;
            if (this.availablect_count === 0) {
                Dialog.confirm({
                    title: 'Tips',
                    content: 'Please activate your kyc partner before entrusting the sale',
                    cancelText: 'Cancel',
                    confirmText: 'Ok',
                    onConfirm: () => console.log('[Dialog.confirm] confirm clicked'),
                })
                return;
            }
            startsell({sell_method: "entrust"}).then(res => {
                if (res.code === 200) {
                    this.$toast.succeed("start sell");
                    setTimeout(() => {
                        that.$router.push('/sell');
                    }, 1200)
                } else {
                    Dialog.confirm({
                        title: 'Tips',
                        content: 'Please activate your kyc partner before entrusting the sale',
                        cancelText: 'Cancel',
                        confirmText: 'Ok',
                        onConfirm: () => {},
                    })
                }
            })
        },
        start_c2c() {
            if (this.$store.state.userinfo.in_c2c) {
                this.$router.push('/sell');
                return;
            }
            let that = this;
            if (this.availablepay_count === 0) {
                Dialog.confirm({
                    title: 'Tips',
                    content: 'Please add your payment method first',
                    cancelText: 'Cancel',
                    confirmText: 'Ok',
                    onConfirm: () => {},
                })
                return;
            }
            startsell({sell_method: "c2c"}).then(res => {
                if (res.code === 200) {
                    this.$toast.succeed("start c2c sell");
                    setTimeout(() => {
                        that.$router.push('/sell');
                    }, 1200)
                } else {
                    that.$toast.failed(res.errmsg);
                }
            })
        },
        confirm_buy() {
            if (Number(this.amount) <= 0 || this.amount_error !== '') {
                this.$toast.failed("incorrect amount");
                return;
            }
            if (this.recharge_method === 'usdt') {
                // usdt method
                this.$router.push('/depositusdt/' + this.amount);
            } else {
                this.$router.push('/buyitokeninr/' + this.amount);
            }
        },
        calculate_itoken(newVal) {
            newVal = Number(newVal);
            if (this.recharge_method === 'usdt') {
                if (newVal > Number(this.$store.state.siteconfig.cw_usdt_recharge_reward_minamount)) {
                    this.gift = Number(this.$store.state.siteconfig.cw_usdt_recharge_reward) * this.exchangerate;
                }
                this.principal = newVal * this.exchangerate
                let principal_reward = newVal * Number(this.$store.state.userinfo.bonus_ratio) * Number("0.01") * this.exchangerate;
                this.reward = principal_reward + this.gift;
                this.get_itoken = this.principal + this.reward;
            } else {
                // inr
                let mode_set = JSON.parse(this.$store.state.siteconfig.pay_reward_amount);
                this.principal = newVal;
                let principal_reward = newVal * Number(this.$store.state.userinfo.bonus_ratio) * Number("0.01");
                if (mode_set.mode === 'ratio') {
                    this.gift = newVal * Number(mode_set.reward) * Number("0.01");
                } else {
                    this.gift = Number(mode_set.reward);
                }
                this.reward = (principal_reward + this.gift).toFixed(2);
                this.get_itoken = this.principal + Number(this.reward);
            }
        },
        onSwiperChange(from, to) {
            this.current = to;
        },
        onTabChange(item, index) {
            this.$refs.swiper.goto(index)
        },
        get_cwexchangerate() {
            getcwexchangerate().then(res => {
                this.exchangerate = res.data.exchangerate;
            })
        },
        go_manage_kyc() {
            this.$router.push('/kycpartner')
        },
        go_manage_payment_methods() {
            this.$router.push('/paymentmethods');
        },
        go_buy_tutorial() {
            if(this.recharge_method === 'usdt') {
                this.$router.push('/newdedetailcode/' + organization + 'usdtbuytutorial');
            } else {
                this.$router.push('/newdedetailcode/' + organization + 'inrbuytutorial');
            }
        },
        get_availablect_count() {
            availablect({ allow_cts: 'all' }).then(res => {
            if (res.code === 200) {
                    this.isSelectorShow = true;
                    if (Object.keys(res.data).length !== 0) {
                        this.availablect_text = "In Active: " + res.data.length;
                        this.availablect_count = res.data.length;
                    }
                }
            })
        },
        get_payments_count() {
            getpayments().then(res=>{
                if(res.code === 200) {
                    if(Object.keys(res.data).length !== 0) {
                        this.availablepay_count = res.data.length;
                        this.availablepay_text = "In Active: " + res.data.length;
                    }
                }
            })
        }
    }

}
</script>


<style scoped>
.noassets>>>.md-result-image {
    width: 1.6rem;
}

.noassets>>>.md-result-text {
    margin: 0;
    color: #01080f;
    font-size: 0.12rem;
}

.noassets>>>.md-result-subtext {
    margin-top: 0.16rem;
    color: red;
    font-size: 0.28rem;
}

.free-text {
    color: #4a4a4a;
    font-size: 0.18rem;
    text-align: center;
}

.reward-text {
    font-size: 0.2rem;
    color: red;
}

.usdt-text {
    color: #f0b90b;
}

.payment-options {
    display: flex;
    justify-content: center;
    align-items: center;
}

.payment-options-radio {
    flex-basis: 100px;
    flex-grow: 1;
    margin: 0 10px;
}

.btngroup .holder {
    margin: 10px auto;
    display: block;
    width: 80px;
    height: 80px;
    border-radius: 50%;
}

.holder {
    line-height: 0px;
    font-size: 39px;
}

.btnitem .title {
    font-size: 0.26rem;
    margin: 0.05rem;
}

.btngroup {
    margin: 0.2rem 0;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}

.btngroup .btnitem {
    text-align: center;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    width: calc(90% / 3);
    height: calc(90% / 3);
    border-radius: 20px;
    box-shadow: 0 8px 12px #ebedf0;
    overflow: auto;
}

.assetslist-img {
    width: 0.42rem;
}

.assetslist .holder {
    line-height: 0px;
    font-size: 39px;
}

.assetslist-img {
    width: 0.42rem;
}

.assetslist>>>.md-cell-item-right {
    color: black;
}

.md-card-button {
    color: #198cff;
    display: inline-block;
    padding: 0.07rem 0.07rem;
    background: #198cff;
    position: relative;
    background: 0 0;
    border-radius: 0.16rem;
    border: 3px solid #198cff;
}

.main {
    margin-top: 1rem;
}

.goodscard-group {
    background: #f3f3f6;
    margin: 10px 0;
    border-radius: 20px;
    overflow: hidden;
    padding: 20px;
}

.cell-group {
    background: #232b63;
    margin: 10px 16px;
    border-radius: 20px;
    overflow: hidden;
    padding: 20px;
}

.cell-group>>>.md-cell-item-title {
    color: #f9fafb !important;
}

.cell-group>>>.md-cell-item-body.multilines:before {
    content: none !important;
}

.header-slot {
    padding: 40px 0 20px 0;
}

.header-slot .title {
    color: #111A34;
    font-size: 60px;
    font-family: Songti SC;
    line-height: 1;
}

.header-slot .desc {
    margin-top: 16px;
    color: #858B9C;
    font-size: 26px;
}

.md-field {
    padding: 0rem 0.4rem 0 0.4rem;
}

.intrust-item {
    font-size: 0.26rem;
}

.intrust-item>>>.batch {
    color: black;
}

.intrust-item .batchd {
    margin-left: -9px;
}

.intrust-item .completion {
    margin-left: -0.19rem;
}

.intrust-item .price {
    color: black;
    font-size: 0.3rem;
}

.intrust-item .price .price-text {
    color: #2c3e50;
    font-size: 0.2rem;
}

.intrust-item .price .amount {
    font-weight: 200;
    font-size: 0.3rem;
}

.intrust-item div {
    margin: 4px;
}

.sii-gift {
    color: gold;
}

.tablist >>> .md-tab-bar-end {
    height: unset !important;
}
.inbtn
{
    margin: 0 0.2rem;
}
</style>


// WEBPACK FOOTER //
// src/views/transaction.vue